import React from 'react';

import Search from '@/components/Search';
import { useFeatures } from '@/features/features/providers/FeaturesProvider';

// import SectionEspecialidades from '../SectionEspecialidades';
import SectionProtocolos from '../SectionProtocolos';
import SectionProtocolosEmExecucao from '../SectionProtocolosEmExecucao';

import { Container, Header } from './styles';

const PageContentProtocolos: React.FC = () => {
  const [termOfSearch, setTermOfSearch] = React.useState('');
  const { hasFeature } = useFeatures();

  // Empresas com a feature "portal.acesso" usam a experiência do portal
  // pessoal na listagem de protocolos, mesmo sendo usuários b2b.
  const portal = hasFeature('portal.acesso') ? 'personal' : 'b2b';

  return (
    <Container>
      <Header>
        <Search
          placeholder="Busque por protocolos ou sintomas"
          onChange={setTermOfSearch}
          debounceTimeInMS={600}
        />
      </Header>

      <SectionProtocolosEmExecucao search={termOfSearch} />
      <SectionProtocolos portal={portal} search={termOfSearch} />
    </Container>
  );
};

export default PageContentProtocolos;
